
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SimpleMap from '../../../../core/components/Map/SimpleMap.vue';
import LabelWithValue from '../../../../core/components/Indicators/LabelWithValue.vue';
import LoadingIndicator from '../../../../core/components/Generics/LoadingIndicator.vue';
import Button from '../../../../core/components/Generics/Button.vue';
import { Units } from '../../../../typescript/values/unitLabels';
import { SatellitalLayersInfo, ZonificationInfo } from '../../../../typescript/satellital/layers';

@Component({
  components: {
    SimpleMap,
    LabelWithValue,
    Button,
    LoadingIndicator
  },
})
export default class SurfaceZonificationItem extends Vue {
  @Prop({default: ''}) modalTitle: string;
  @Prop({ default: true }) showZones!: boolean;
  @Prop({default: {
    date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null
  }}) info: ZonificationInfo;

  defaultValues: object = {
     date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null
  }

  summaryInfo: ZonificationInfo = {
    date: null,
    bar_url: '',
    png_url: null,
    total_area: null,
    zones: [],
    bounds: null
  }
  minWidthValueSummary: number = 80;
  minWidthValue: number = 120;
  zonesPanel: number | undefined = undefined;

  get fixedLabelWidth() {
    // Use a fixed width that accommodates most labels with wrapping
    return 140;
  }

  get hasZones(): boolean {
    return (this.summaryInfo.zones || []).length > 0;
  }

  zoneValue(zone: any): string {
    return zone.value != null ? zone.value : (zone.valor != null ? zone.valor : '-');
  }

  mounted(){
    this.summaryInfo = this.info;
  }

  @Watch('info', {immediate: true, deep: true})
  onInfoChanged(newInfo){
    this.summaryInfo = newInfo;
  }

  
  labelsUnits = Units;
  loadingIndicators: boolean = true;


  updateLoadingIndicator(value: boolean){
    console.log('updateLoadingIndicator deberia apagar el cargando...', value)
    this.loadingIndicators = value;
  }

  updateLayersInfo(info: ZonificationInfo){
    if(info == null){
      info = this.defaultValues as ZonificationInfo
    }
    this.summaryInfo = info
  }
}
